
<app-header></app-header>
<div class="container main-container">

    <app-menu-tabs [filter]="filter"></app-menu-tabs>

    <ng-container *ngIf="filter === 'ONLY_EXHIBITORS' || ( favorites && exhibitors.length > 0)">

        <h2 class="container-fluid subtitle subtitle--exhibitor" *ngIf="favorites">{{ 'MY_FAVORITES.EXHIBITORS' | translate }}</h2>

        <div class="container-fluid counter" *ngIf="!favorites">
            {{ exhibitors.length }} {{ 'EXHIBITORS.TITLE' | translate }}
        </div>

        <div class="container-fluid">
            <card-grid *ngIf="selectedView === 'grid'" [page]="0" [items]="exhibitors" [show]="show" ></card-grid>
            <card-modern *ngIf="selectedView === 'modern'" [page]="0" [items]="exhibitors" [show]="show"></card-modern>
            <card-list *ngIf="selectedView === 'list'" [page]="0" [items]="exhibitors" [show]="show"></card-list>
        </div>
        
        <app-no-results *ngIf="exhibitors.length === 0 && !favorites && loader.count === 0"></app-no-results>
    </ng-container>

    <ng-container *ngIf="filter === 'ONLY_PRODUCTS' || ( favorites && products.length > 0)">
        
        <h2 class="container-fluid subtitle subtitle--products" *ngIf="favorites">{{ 'MY_FAVORITES.PRODUCTS' | translate }}</h2>

        <div class="container-fluid counter" *ngIf="!favorites">
            {{ products.length }} {{ 'PRODUCTS.TITLE' | translate }}
        </div>

        <div class="container-fluid">
            <card-grid *ngIf="selectedView === 'grid'" [page]="0" [items]="products" [show]="show" ></card-grid>
            <card-modern *ngIf="selectedView === 'modern'" [page]="0" [items]="products" [show]="show"></card-modern>
            <card-list *ngIf="selectedView === 'list'" [page]="0" [items]="products" [show]="show"></card-list>
        </div>

        <app-no-results *ngIf="products.length === 0 && !favorites && loader.count === 0"></app-no-results>

    </ng-container>


    <ng-container *ngIf="favorites && products.length === 0 && exhibitors.length === 0 && loader.count === 0">

        <div class="no-favorites-container">
            <img class="no-favorites-img" width="140" height="140" [alt]="'noFavorites' | customTranslation" src="assets/img/no-favorites.svg">
            <h2 class="no-favorites-title">{{ 'MY_FAVORITES.NO_RESULTS_EMPTY_LIST' | translate }}</h2>
            <div class="no-favorites-row1">
                <span>{{ 'MY_FAVORITES.NO_RESULTS_TXT_1_1' | translate }}</span>
                <img width="24" height="24" [alt]="'favorites' | customTranslation" src="assets/img/favorite_border.svg">
                <span>{{ 'MY_FAVORITES.NO_RESULTS_TXT_1_2' | translate }}</span>
            </div>
            <div class="no-favorites-row2">
                <span>{{ 'MY_FAVORITES.NO_RESULTS_TXT_2' | translate }}</span>
            </div>
            <div class="see_more_button" [style.color]="eventData['pageColor']" routerLink="/{{eventData.eventName}}/home" [queryParams]="{filter: 'ONLY_EXHIBITORS'}" [style.backgroundColor]="eventData['mainColor']">
                {{ 'MY_FAVORITES.START_EXPLORING' | translate }}
            </div>
        </div>
          
    </ng-container>
    
    <loader-throbber *ngIf="loader.count > 0"></loader-throbber>

</div>

<app-footer></app-footer>
